export const CONTENT_TYPES = {
  LIST: 'List',
  TRUSTPILOT: 'Trustpilot',
  TEXT: 'Text',
} as const;

export type ContentType = (typeof CONTENT_TYPES)[keyof typeof CONTENT_TYPES];
